import type { CandidateResume } from '../types';
import { mockCandidateActivitySphere } from './mockCandidateActivitySphere';
import { mockCandidateCurrency } from './mockCandidateCurrency';
import { mockCandidateNamedReference } from './mockCandidateNamedReference';
import { mockCandidatePaymentPeriod } from './mockCandidatePaymentPeriod';

export function mockCandidateResume(
  overrides: Partial<CandidateResume> = {}
): CandidateResume {
  return {
    resumeId: 1,
    candidateId: 1,
    firstName: 'John',
    lastName: 'Doe',
    age: 28,
    phone: '+33123456789',
    preferredCommunicationLanguage: 'English',
    salary: 5000,
    desiredJob: 'Frontend developer',
    experience: 'Five years of frontend development experience',
    employmentDate: '2026-08-01T00:00:00.000Z',
    is_active: true,
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-07-15T12:30:00.000Z',
    currency: mockCandidateCurrency(),
    paymentPeriod: mockCandidatePaymentPeriod(),
    activitySpheres: [mockCandidateActivitySphere()],
    employmentTypes: [mockCandidateNamedReference()],
    scheduleWorks: [
      mockCandidateNamedReference({
        id: 2,
        name: 'Remote',
        slug: 'remote',
      }),
    ],
    skills: [
      mockCandidateNamedReference({
        id: 3,
        name: 'React',
        slug: 'react',
      }),
    ],
    vacancies: [
      {
        id: 1,
        name: 'Frontend developer',
        salaryFrom: 4000,
        salaryTo: 6000,
        mandatoryRequirements: 'At least two years of React experience',
        additionalRequirements: 'TypeScript experience is preferred',
        responsibilities: 'Develop and maintain user interfaces',
        requiredCandidatesCount: 2,
        startDate: '2026-08-01',
        status: 'selection_in_progress',
        interviewFinalMessage: null,
        ai_sphere_fill: true,
        createdAt: '2026-06-01T10:00:00.000Z',
        updatedAt: '2026-07-10T10:00:00.000Z',
        candidateVacancyStatus: 'proposed',
        candidateVacancyMatchPercent: 85,
        candidateVacancyCreatedAt: '2026-07-01T09:00:00.000Z',
        decisionType: 'PENDING',
      },
    ],
    ...overrides,
  };
}
